exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-list[data-v-9105a0c6] {\n\theight: 40px;\n}\n.custom-icon[data-v-9105a0c6] {\n\tdisplay: flex;\n\tjustify-content: start;\n\talign-items: center;\n\twidth: 40px;\n\theight: 40px;\n\tbackground-color: #f5f7f9;\n\tborder-radius: 50%;\n\tpadding: 8px;\n}\n.custom-item[data-v-9105a0c6] {\n\tdisplay: flex;\n\tjustify-content: start;\n\talign-items: center;\n\twidth: 74%;\n\theight: 40px;\n\tpadding: 10px 0px 0px 16px;\n}\n.custom-arrow-right[data-v-9105a0c6] {\n\tdisplay: flex;\n\tjustify-content: end;\n\talign-items: center;\n\twidth: 10%;\n\theight: 40px;\n}\n.custom-divider[data-v-9105a0c6] {\n\tmargin-top: 0px;\n}\n", ""]);

// exports
